import React from 'react';
import 'react-app-polyfill/ie11';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { HashRouter } from 'react-router-dom';
import { AuthContextProvider } from './store/auth-context';
import store from './store/index';
import AppWrapper from './AppWrapper';
import Loader from './components/_shared/Loader';

ReactDOM.render(
  <Provider store={store}>
    <HashRouter>
      <AuthContextProvider>
        <AppWrapper></AppWrapper>
      </AuthContextProvider>
    </HashRouter>
    <Loader />
  </Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
//serviceWorker.unregister();
